<template>
	<form class="full-width column flexible article" @submit="submitForm">
		<header class="row centering separated">
			<h1 class="rigid capitalize">Setup your account</h1>
		</header>
		<div class="column panel flexible">
            <v-spinner v-if="userStatus.loading"></v-spinner>
			<address-form v-else :is-submitting="submitting" @clear-error="createAddressError = null" :error="createAddressError" @change="onAddressChange"></address-form>
		</div>

		<footer class="row rigid separated right centering">
		    <a v-if="navigation.start.view" class="link rigid" :href="navigation.start.view"><small><i class="fas fa-arrow-left"></i></small> {{navigation.start.name}}</a>
			<span class="gap"></span>
			<submit-button class="primary rigid" :button-text="'Continue'" :is-submitting="submitting" :is-disabled="submitDisabled"></submit-button>
		</footer>

	</form>
</template>

<script>
import AddressForm from '@/components/AddressForm';
import Spinner from '@/components/Spinner';
import { mapGetters } from 'vuex';
import ENV_VARS from '@/modules/env-vars.js';
import SubmitButton from '@/components/SubmitButton';

export default {
	name: 'Address',
	components:{
		AddressForm,
		SubmitButton,
		Spinner
	},
	props: {
		navigation: Object
	},
	data(){
		return {
			submitting: false,
			createAddressError :null,
			newAddress: null,
			currentStep: 'setup',
		};
	},
	computed:{
		...mapGetters([
			'address',
			'userStatus',
		]),
		submitDisabled() {
			return this.createAddressError != null || !this.newAddress || (this.newAddress && !this.newAddress.complete) || this.submitting;
		}
	},
	methods:{
		onAddressChange(val){
			this.newAddress = val;
		},
		submitForm(e){
			e.preventDefault();
			let vm = this;
			this.submitting = true;

			this.$store.dispatch('CREATE_ADDRESS_REQUEST', this.newAddress)
				.then(() => {
					vm.$store.dispatch('SET_ADDRESSES', [vm.newAddress]);
					// returns empty string so just use the payload
					vm.submitting = false;
					const iterateBy = this.newAddress.country !== 'US' ? 2 : 1;
					// if address is non-us, skip to the next step
					vm.$emit('navigation', vm.navigation.currentIndex + iterateBy);
				})
				.catch(reason => {
					vm.createAddressError = reason;
					vm.submitting = false;
				});
		}
	}
};
</script>

<style scoped>
address {
	color: #555;
}
address > div {
	margin-bottom: 2px;
}
.panel {
	background: white;
	border-radius: 6px;
	padding: 2rem;
	border: 2px solid #dfdfdf;
	width: 100%;
	margin: auto;
	box-sizing: border-box;
}
.dark .panel {
	background: #1a1a1a;
	border: 2px solid #333;
}

.panel + footer {
	margin-top: 2em;
}

</style>



// WEBPACK FOOTER //
// ./src/views/promotions/Address.vue